// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hbD0F","inputTitle":"styles_inputTitle__+CBB3"};